import Avatar, { type AvatarProps } from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

interface UserAvatarProps extends AvatarProps {
  fullName: string;
  primary: boolean;
}

function getBackgroundColor(primary: boolean) {
  let backgroundColor = '';
  let textColor = '';

  if (primary) {
    backgroundColor = 'primary.main';
    textColor = 'text.primary';
  } else {
    backgroundColor = 'common.black';
    textColor = 'common.white';
  }

  return { backgroundColor, textColor };
}

function getInitialsAvatarProps(name: string, primary: boolean) {
  const { backgroundColor, textColor } = getBackgroundColor(primary);
  const [firstName = '', lastName = ''] = name.split(' ');
  return {
    sx: { backgroundColor: backgroundColor, fontWeight: 'bold', color: textColor },
    children: `${firstName.charAt(0)}${lastName.charAt(0)}`,
  };
}

const BaseAvatar = forwardRef<HTMLDivElement, UserAvatarProps>((props: UserAvatarProps, ref) => {
  const { fullName, primary: isPrimary = false, ...restProp } = props;
  return <Avatar {...restProp} {...getInitialsAvatarProps(fullName, isPrimary)} ref={ref} />;
});

BaseAvatar.displayName = 'UserAvatar';

const UserAvatar = styled(BaseAvatar)``;

export { UserAvatar };
export type { UserAvatarProps };
